exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-tab-list[data-v-dee98736] {\n  padding: 10px;\n  position: initial;\n}\n.review-contents[data-v-dee98736] {\n  display: contents !important;\n}\n.collapse-panel[data-v-dee98736]  i.md-icon.md-icon-font.md-theme-default {\n  float: left !important;\n  position: initial !important;\n  margin-top: -2px;\n}\n.collapse-panel[data-v-dee98736]  i.md-icon.md-icon-font.md-icon-image.md-date-icon.md-theme-default {\n  margin-top: 6px !important;\n}\n.collapse-panel-zindex[data-v-dee98736] {\n  z-index: 0;\n}\n.ontop[data-v-dee98736] {\n  z-index: 2;\n}\n", ""]);

// exports
